module.exports = __webpack_public_path__ + "img/planner-2.437dea6a.png";